"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatTypeEnum = void 0;
var ChatTypeEnum;
(function (ChatTypeEnum) {
    ChatTypeEnum["WebsiteWidget"] = "Website Widget";
    ChatTypeEnum["SMS"] = "SMS";
    ChatTypeEnum["All"] = "All";
})(ChatTypeEnum = exports.ChatTypeEnum || (exports.ChatTypeEnum = {}));
